"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogPayloadToJSON = exports.LogPayloadFromJSONTyped = exports.LogPayloadFromJSON = void 0;
const runtime_1 = require("../runtime");
function LogPayloadFromJSON(json) {
    return LogPayloadFromJSONTyped(json, false);
}
exports.LogPayloadFromJSON = LogPayloadFromJSON;
function LogPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'stack': !runtime_1.exists(json, 'stack') ? undefined : json['stack'],
        'message': !runtime_1.exists(json, 'message') ? undefined : json['message'],
    };
}
exports.LogPayloadFromJSONTyped = LogPayloadFromJSONTyped;
function LogPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'stack': value.stack,
        'message': value.message,
    };
}
exports.LogPayloadToJSON = LogPayloadToJSON;
//# sourceMappingURL=LogPayload.js.map